import React from 'react';

import Icons from '@/core/components/Icons';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

const BadgePunctual: React.FC = () => {
  const { t } = useTranslationContext(['common']);

  return (
    <div className="flex items-center justify-center gap-[2px] rounded-2 bg-bg-pale p-[2px]">
      <Icons icon="watch" size="12" weight="light" />
      <p className="text-caption-primary font-medium text-content-primary">{t('components.badges.is-punctual', { ns: 'common' })}</p>
    </div>
  );
};

export default BadgePunctual;
